export default __webpack_public_path__ + "static/110-e365e479ef438994e28be91f7943b762.gif";